import { VoiceMessageBuilder } from "../lines/voice-message.builder";
var WaitOfferSettingsBuilder = /** @class */ (function () {
    function WaitOfferSettingsBuilder() {
        this.waitOfferSettings = {
            enabled: true,
            waitOfferMessage: new VoiceMessageBuilder().build(),
            waitOfferOptions: [],
            waitOfferThresholds: {
                enableOfferPerAudioIterations: true,
                enableOfferPerCalls: true,
                maxAudioIterationsThreshold: 10,
                maxWaitingCallsThreshold: 10
            }
        };
    }
    WaitOfferSettingsBuilder.prototype.withVoiceMessage = function (waitOfferMessage) {
        this.waitOfferSettings.waitOfferMessage = waitOfferMessage;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.waitOfferSettings.enabled = enabled;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withWaitOfferOptions = function (waitOfferOptions) {
        this.waitOfferSettings.waitOfferOptions = waitOfferOptions;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withWaitOfferThresholds = function (waitOfferThresholds) {
        this.waitOfferSettings.waitOfferThresholds = waitOfferThresholds;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.build = function () {
        return this.waitOfferSettings;
    };
    return WaitOfferSettingsBuilder;
}());
export { WaitOfferSettingsBuilder };
//# sourceMappingURL=wait-offer-settings-builder.js.map